import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpStatusCode } from "axios";

import { findId } from "../../../services/authServices";

import useIdentityVerification from "../../../hooks/useIdentityVerification";

import StickyHeader from "../../../components/Layout/StickyHeader";
import HorizontalRule from "../../../components/Rule/Horizontal";
import CommonButton from "../../../components/Button";
import { MyProfileKakaoIcon } from "../../MyInfo";
import CommonPopup from "../../../components/Popup";

type Props = {};

export default function FindId(props: Props) {
  const navigate = useNavigate();
  const [popup, setPopup] = useState<"userUnmatched" | "">("");
  const [
    {
      data: identifyData,
      isComplete: isCompleteIdentity,
      validate: validateIdentity,
    },
    identifyComponent,
  ] = useIdentityVerification({ needDuplicate: true });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pb-20">
      <StickyHeader
        title="아이디 찾기"
        onBackClick={() => navigate("/auth/login")}
        className="px-5"
      />
      <div className="px-5">
        <div className="pt-5 pb-[33px] text-3xl font-light">
          아이디를 찾기 위한
          <br />
          <strong className="font-medium">본인 확인</strong>을 진행할게요
        </div>
        <HorizontalRule margin="0" className="bg-brand-neutral-05" />

        <div className="pt-[30px] flex flex-col gap-5">
          {identifyComponent}
          <div className="py-5 px-2.5 flex flex-col gap-2.5 bg-brand-weather-badge-background items-center rounded-[3px]">
            <div className=" text-sm text-brand-neutral-80 whitespace-pre-line text-center">
              {"이메일 찾기에 어려움이 있다면,\n카카오톡으로 문의해 주세요."}
            </div>
            <a href="https://pf.kakao.com/_xhJxkZK/chat">
              <CommonButton
                variant="transparent"
                className="!bg-[#fee500] w-fit px-4 py-[11px] text-sm text-black font-medium"
              >
                <MyProfileKakaoIcon />
                카카오톡 문의
              </CommonButton>
            </a>
          </div>

          <div className=" h-bottom-button fixed bottom-0 left-0 right-0 bg-white">
            <CommonButton
              validation={!isCompleteIdentity}
              className="w-full h-bottom-button rounded-none whitespace-nowrap"
              onClick={() => {
                if (!validateIdentity()) return;

                findId({
                  name: identifyData.name?.trim() as string,
                  mobileNumber: identifyData.mdn as string,
                  memberCi: identifyData.ci as string,
                })
                  .then((res) => {
                    if (res.status === HttpStatusCode.Ok) {
                      navigate("/auth/findId/complete", {
                        state: {
                          email: res.data.email,
                          createdAt: res.data.createdAt,
                        },
                      });
                    }
                  })
                  .catch((reason) => {
                    setPopup("userUnmatched");
                  });
              }}
            >
              인증하기
            </CommonButton>
          </div>
        </div>
      </div>

      <CommonPopup
        isOpen={popup === "userUnmatched"}
        title="사용자 불일치"
        unUseHorizonRule
        padding={0}
        onClose={() => setPopup("")}
      >
        <div className="px-5 pb-5">
          <div className="py-2.5 flex flex-col gap-2.5 items-center">
            <FindIdInfoIcon />
            <div className=" whitespace-pre-line text-center text-brand-neutral-60 text-sm">
              {
                "요청하신 인증 정보와 맞는 사용자가 없어요.\n이름과 전화 번호를 확인해주세요."
              }
            </div>
          </div>
        </div>
        <CommonButton
          className="h-bottom-button w-full rounded-none"
          onClick={() => setPopup("")}
        >
          확인
        </CommonButton>
      </CommonPopup>
    </div>
  );
}

export const FindIdInfoIcon = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.39972 30.3994C5.39972 44.2065 16.5926 55.3994 30.3997 55.3994C44.2068 55.3994 55.3997 44.2065 55.3997 30.3994C55.3997 16.5923 44.2068 5.39941 30.3997 5.39941C16.5926 5.39941 5.39972 16.5923 5.39972 30.3994Z"
      stroke="#1D1929"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M30.4012 19.5205V30.9517"
      stroke="black"
      strokeWidth="3"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M30.3892 38.9912H30.4097"
      stroke="black"
      strokeWidth="3"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
